import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditRatingPayload } from '@app-store/slices/momentum/editRating'

interface TaskAction extends Action {
    payload: IEditRatingPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.momentum.edit

function* momentumEditRateSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.patch(`/meeting/rating/${payload.rateId}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload?.sagaCB && payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload?.sagaCB && payload.sagaCB?.onError()
    }
}

function* momentumEditRateSaga(): any {
    yield takeLatest<TaskAction>(onRequest, momentumEditRateSagaTask)
}

export default momentumEditRateSaga
